(() => {
  const PRICE_SORTS = new Set(['price-ascending', 'price-descending']);

  function sortOriginalArtworkGrids(root = document) {
    root.querySelectorAll('[data-original-artwork-sort="true"]').forEach((grid) => {
      const sortBy = grid.dataset.sortBy;

      if (!PRICE_SORTS.has(sortBy)) return;

      const items = Array.from(grid.children);
      const sortedItems = items
        .map((item, index) => ({
          item,
          index,
          price: Number(item.dataset.originalArtworkPrice || 0),
        }))
        .sort((a, b) => {
          const priceDifference =
            sortBy === 'price-ascending' ? a.price - b.price : b.price - a.price;

          return priceDifference || a.index - b.index;
        })
        .map(({ item }) => item);

      const orderChanged = sortedItems.some((item, index) => item !== items[index]);
      if (!orderChanged) return;

      const fragment = document.createDocumentFragment();
      sortedItems.forEach((item, index) => {
        item.style.setProperty('--animation-order', index + 1);
        fragment.appendChild(item);
      });
      grid.appendChild(fragment);
    });
  }

  let sortScheduled = false;
  function scheduleSort() {
    if (sortScheduled) return;
    sortScheduled = true;

    requestAnimationFrame(() => {
      sortScheduled = false;
      sortOriginalArtworkGrids();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleSort, { once: true });
  } else {
    scheduleSort();
  }

  const observer = new MutationObserver((mutations) => {
    const productGridChanged = mutations.some((mutation) => {
      const target = mutation.target;
      return target instanceof Element && Boolean(target.closest('#ProductGridContainer'));
    });

    if (productGridChanged) scheduleSort();
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
